
$(document).ready(function () {
    var $pdNav = $('#pd-nav');
    if (!$pdNav.length) {
        return;
    }
    var stickyOffset = $pdNav.offset().top;

    $(window).scroll(function () {
        if ($(window).scrollTop() >= stickyOffset) {
            // Element is sticky
            $pdNav.addClass('is-sticky');
            $('#pd-logo').addClass('is-sticky');
        }
        else {
            // Element is not sticky
            $pdNav.removeClass('is-sticky');
            $('#pd-logo').removeClass('is-sticky');
        }
    });
});
